import styled from 'styled-components';

import { BLACK, WHITE, SCREEN_LOCKUP_WIDTH, MOBILE_PADDING, PAGE_WIDTH } from '../../../styles/variables.style';

import media from '../../../styles/media.style';

export const Wrapper = styled.section`
  margin: auto;
  max-width: ${PAGE_WIDTH}px;
  padding-bottom: 40px;
  width: 100%;
`;

export const ImageWrapper = styled.div`
  height: fit-content;
  width: 100%;
  margin-bottom: 30px;

  ${media.tabletL`
    margin-bottom: 85px;
  `};
`;

export const InfoWrapper = styled.div`
  margin: 0 auto;
  max-width: ${SCREEN_LOCKUP_WIDTH + MOBILE_PADDING * 2}px;
  padding: 0 ${MOBILE_PADDING}px;

  ${media.tabletL`
    display: flex;
    justify-content: space-between;
    max-width: ${SCREEN_LOCKUP_WIDTH + MOBILE_PADDING * 4}px;
    padding: 0 ${MOBILE_PADDING * 2}px;
  `};
`;

export const TitleWrapper = styled.div`
  margin-bottom: 30px;

  ${media.tabletL`
    margin-bottom: 0;
    width: 45%;
  `};
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 38px;
  line-height: 1.26;
  letter-spacing: 0.5px;
  text-transform: uppercase;
`;

export const BenefitsWrapper = styled.div`
  margin-top: 15px;
`;

export const Benefit = styled.div`
  font-size: 18px;
  line-height: 1.39;
`;

export const DescriptionWrapper = styled.div`
  ${media.tabletL`
    width: 45%;
  `};
`;

export const Description = styled.div`
  h1 {
    font-size: 24px;
    margin: 0;

    ${media.tabletL`
      font-size: 28px;
    `};
  }

  h2 {
    font-size: 20px;
    margin: 20px 0 0 0;

    ${media.tabletL`
      font-size: 24px;
    `};
  }

  h3 {
    font-size: 18px;
    margin: 20px 0 0 0;

    ${media.tabletL`
      font-size: 20px;
    `};
  }

  p {
    font-size: 14px;
    line-height: 1.43;
    letter-spacing: 0.1px;
    margin: 20px 0 0 0;
    white-space: pre-line;

    ${media.tabletL`
      font-size: 18px;
      line-height: 1.39;
    `};
  }
`;

export const ButtonWrapper = styled.div`
  margin-top: 40px;
  width: 100%;
  ${media.tabletL`
    margin-top: 80px;
  `};
`;
export const ButtonWrapperJp = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 40px auto 0;

  .button {
    width: 220px;
    align-items: center;
    background-color: ${BLACK};
    color: ${WHITE};
    cursor: pointer;
    display: flex;
    height: 64px;
    justify-content: center;
    margin-right: 10px;
    margin-left: 10px;
    ${media.tabletL`
      width: 320px;
    `};
  }

  ${media.tabletL`
    margin-top: 80px;
  `};
`;
export const ButtonJp = styled.div`
  width: 220px;
  align-items: center;
  background-color: ${BLACK};
  color: ${WHITE};
  cursor: pointer;
  display: flex;
  height: 64px;
  justify-content: center;
  margin-right: 10px;
  margin-left: 10px;
  ${media.tabletL`
    width: 320px;
  `};
`;
export const Button = styled.div`
  width: 220px;
  align-items: center;
  background-color: ${BLACK};
  color: ${WHITE};
  cursor: pointer;
  display: flex;
  height: 64px;
  justify-content: center;
  margin: 0 auto;

  ${media.tabletL`
    width: 320px;
  `};
`;

export const PlaceholderWrapper = styled.div`
  text-align: center;
`;



// WEBPACK FOOTER //
// ./src/pages/RangePage/RangeHeroOverview/RangeHeroOverview.style.js